export default "__VITE_ASSET__BDzIBBDl__"